import { ButtonGroup } from '@toggle/design-system';
import { Entity } from '@toggle/toggle';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetEarningById } from '~/hooks/use-get-earning-by-id/useGetEarningById';

import { HistoricalReaction } from './historical-reaction/HistoricalReaction';
import { MarketReaction } from './market-reaction/MarketReaction';
import * as S from './MarketReactionSection.styles';

interface MarketReactionSectionProps {
  entity: Entity;
  earningsId: string;
  reportingDate: string;
}

export const MarketReactionSection = ({
  entity,
  earningsId,
  reportingDate,
}: MarketReactionSectionProps) => {
  const { t } = useTranslation(['earnings']);
  const buttonOptions = useMemo(
    () => [
      t('earnings:earningsInsight.drawer.earningsRecap.marketReaction'),
      t('earnings:earningsInsight.drawer.earningsRecap.historicalReaction'),
    ],
    [t]
  );
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(0);
  const isMarketReactionSelected = selectedButtonIndex === 0;

  const { data: earningsData, isLoading } = useGetEarningById(earningsId);

  const hasEpsData = !isLoading && earningsData?.eps?.surprise !== undefined;

  return (
    <S.Root>
      {hasEpsData && (
        <>
          <S.StyledButtonGroup>
            <ButtonGroup
              labels={buttonOptions}
              activeIndex={selectedButtonIndex}
              onClick={setSelectedButtonIndex}
            />
          </S.StyledButtonGroup>
          {!isMarketReactionSelected && (
            <HistoricalReaction entity={entity} earningsId={earningsId} />
          )}
        </>
      )}
      {(!hasEpsData || isMarketReactionSelected) && (
        <MarketReaction
          reportingDate={reportingDate}
          subscribableTicker={entity.subscribable_ticker ?? ''}
        />
      )}
    </S.Root>
  );
};
